











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ShoppingBagIcon from '@/components/atoms/icon/ShoppingBagIcon.vue'

/**
 * ホテラバ専用一覧(hl-itemlist)のピルとは実装を共有しない(あちらは bundle 独立方針による意図的な重複実装)が、
 * 見た目は揃える。
 */
@Component({
  components: {
    ShoppingBagIcon,
  },
})
export default class BundleDiscountPillBadge extends Vue {
  @Prop({ required: true })
  labelColor: string

  @Prop({
    default: 'medium',
    validator: (value: string) => value === 'medium' || value === 'large',
  })
  size: 'medium' | 'large'
}
